import React, { useState } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import  Index  from "../../views/user/Index";
import CleanNavbar from "components/Navbars/CleanNavbar";
import UserSidebar from "components/Sidebar/UserSidebar";
import imgtoData from "../../variables/imgManipulation";
import { getProfileInfo } from "../../network/ApiAxios";
import UserProfile from "views/user/userProfile";
import EditProfile from "views/examples/EditProfile";
import UserDocs from "views/user/UserDocs";

import CheckPermission from "variables/CheckPermission";


const User = () => {
  const history = useHistory();
  const [pic, setpic] = useState();
  const [permission, setPermission] = useState(true);
  
  const permisson = CheckPermission()
      if(!permisson){
        setPermission(false)
      }
  let user;
  user = JSON.parse(localStorage.getItem("user"));

  // eslint-disable-next-line
  const getProfilePic = async () => {
    const data = await getProfileInfo(user.userID);
    if (data.data.data) {
      const dat = data.data.data;
      setpic(imgtoData(dat));
    } else {
      setpic(require("../../assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  let Comp;
  let title;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
      case "/user/profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/user/index":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/user/profile/edit":
        Comp=EditProfile;
        title='Edit Profile';
        break;  
      case "/user/documents":
        Comp=UserDocs;
        title='My Documents';
        break;  
  }



  return permission ? <>
              
              <UserSidebar
              pic={pic}
              logo={{
                innerLink: "/user/index",
                imgSrc: require("../../assets/img/brand/argon-react.png").default,
                imgAlt: "..."
              }}/>
              <div className="main-content">
                <CleanNavbar title={title} />
                <Route
                component={Comp}
                />
              </div>
          </>: <Redirect to='/' />;
};

export default User;
